import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./CollapsibleSection.css";

const CollapsibleSection = ({ 
  id,
  title, 
  description, 
  children, 
  isExpanded = false, 
  className = "", 
  sectionRef,
  isActive = false,
  onToggle = null
}) => {
  // Use local state only if no external controller is provided
  const [internalExpanded, setInternalExpanded] = useState(isExpanded);
  
  // Determine if we're controlled or uncontrolled
  const isControlled = onToggle !== null;
  const expanded = isControlled ? isExpanded : internalExpanded;
  
  // Update internal state when isExpanded prop changes (if uncontrolled)
  useEffect(() => {
    if (!isControlled) {
      setInternalExpanded(isExpanded);
    }
  }, [isExpanded, isControlled]);

  const toggleExpanded = () => {
    if (isControlled) {
      // If we have an external controller, use that
      onToggle();
    } else {
      // Otherwise use internal state
      setInternalExpanded(!internalExpanded);
    }
  };

  return (
    <section
      id={id}
      className={`collapsible-section ${className} ${isActive ? 'active-section' : ''} ${expanded ? 'expanded' : ''}`}
      ref={sectionRef}
    >
      <div className="collapsible-header" onClick={toggleExpanded}>
        <div className="container">
          <div className="header-content">
            <h2 className="section-title force-revue">{title}</h2>
            {description && <p className="section-description">{description}</p>}
          </div>
          <div className="toggle-icon" aria-label={expanded ? "Collapse section" : "Expand section"} aria-expanded={expanded}>
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
        </div>
      </div>
      <div className={`collapsible-content ${expanded ? 'expanded' : ''}`}>
        <div className="container">
          {children}
        </div>
      </div>
    </section>
  );
};

export default CollapsibleSection;